import { render, staticRenderFns } from "./TandaTerimaKasbon.vue?vue&type=template&id=512e34a7"
import script from "./TandaTerimaKasbon.vue?vue&type=script&lang=js"
export * from "./TandaTerimaKasbon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports